import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ClientLogService } from './client-log.service';

/**
 * Reports failed backend calls (network errors and 5xx) to the log sink so they
 * surface in CloudWatch. Skips the sink endpoint itself to avoid a loop, and
 * skips expected 4xx (validation/auth) to keep the noise down.
 */
export const clientLogInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('/client-log')) {
    return next(req);
  }
  const logger = inject(ClientLogService);
  return next(req).pipe(
    tap({
      error: (err) => {
        if (err instanceof HttpErrorResponse && (err.status === 0 || err.status >= 500)) {
          logger.log('error', `HTTP ${err.status} ${req.method} ${req.url} - ${err.message}`);
        }
      },
    })
  );
};
